export const backgroundUrl =
  "https://img.alicdn.com/imgextra/i1/O1CN01ZtrCgj1aUZ9U5idqu_!!6000000003333-55-tps-64-56.svg";

export const miniBackgroundUrl =
  "https://img.alicdn.com/imgextra/i1/O1CN01ZtrCgj1aUZ9U5idqu_!!6000000003333-55-tps-64-56.svg";
